// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annuaire-page {
    width: 100%;
    padding: 2rem 3.5rem;
}

.annuaire-page h1 {
    margin-bottom: 3rem;
}

.annuaire-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.entreprise-info {
  display: flex;
  flex-direction: column;
}


.avatar-placeholder {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: #E5E7EB;
  overflow: hidden;
}

.action-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.8rem;
  color: #2C3948;
}

.action-button:hover {
  color: #DA7027;
}

.entreprise-cell {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.entreprise-logo {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 4px;
}

.entreprise-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.entreprise-nom {
  font-weight: 500;
}

.information-cell {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.contact-name {
  font-weight: 700;
}

/* Remplacer le style existant des documents-cell */
.documents-cell {
  position: relative;
  max-width: 60px; /* Réduit car on n'a plus de texte à côté */
}

/* Style pour le bouton qui affichera les documents */
.documents-toggle {
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 0.25rem;
  font-size: 0.8rem;
  cursor: pointer;
  color: #2C3948;
  transition: color 0.2s;
  white-space: nowrap;
}

.documents-toggle:hover {
  color: #DA7027;
}

.documents-toggle svg {
  width: 30px;
  height: 30px;
}

/* Style pour le bouton qui n'affiche que l'icône */
.documents-toggle.documents-icon-counter {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.documents-toggle.documents-icon-counter:hover {
  transform: scale(1.2);
}

.document-outline-icon {
  width: 24px;
  height: 24px;
}

.documents-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 1.5rem;
  margin-left: 0.25rem;
}

/* Popup pour afficher les documents */
.documents-popup {
  position: absolute;
  top: 0%;
  left: -279px;
  margin-bottom: 4px;
  background-color: white;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 100;
  min-width: 280px;
  max-width: 400px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  transition: opacity 0.2s, visibility 0.2s, transform 0.2s;
}

.documents-popup-list {
    display: flex;
    gap: 0.5rem;
    flex-direction: column;
}

/* Pour les lignes en bas du tableau, afficher le popup au-dessus */
.tableau-de-bord-table tr:nth-last-child(-n+3) .documents-popup {
  bottom: auto;
  top: 100%;
  margin-top: 4px;
  margin-bottom: 0;
  transform: translateY(-8px);
}

.documents-cell:hover .documents-popup {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.documents-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.document-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(215, 217, 217, 0.20);
  text-decoration: none;
  font-size: 0.85rem;
  padding: 6px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;  /* Transition douce pour tous les changements */
}

.document-item:hover {
  background-color: rgba(194, 194, 194, 0.46);  /* Couleur de fond au survol */
}

.document-item:active {
  background-color: #E5E7EB;  /* Couleur légèrement plus foncée lors du clic */
  transform: translateY(1px);  /* Léger effet d'enfoncement */
}

.document-item .document-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: color 0.2s;  /* Transition pour la couleur de l'icône */
}

.document-item:hover .document-icon {
  color: #DA7027;  /* Même couleur que le texte au survol */
}

.document-item svg {
  width: 16px;
  flex-shrink: 0;
}

.document-link {
  color: #2C3948;
  text-decoration: none;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-link:hover {
  text-decoration: underline;
  color: #DA7027;
}

/* Animation pour l'apparition du popup */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}

.documents-popup {
  animation: fadeIn 0.2s ease-out;
}

/* Styles pour l'en-tête du tableau */
.tableau-de-bord-header {
  background-color: #F3F4F6;
  font-weight: 600;
}

/* Définir des largeurs fixes pour les colonnes du tableau */
.categorie-cell {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.departement-cell {
  max-width: 120px;
  white-space: nowrap;
}

.rang-cell {
  max-width: 60px;
  text-align: center;
}

.entreprise-cell {
  max-width: 200px;
}

.information-cell {
  max-width: 180px;
}

/* Styles pour les filtres dropdown */
.annuaire-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f7f7f7;
  border-radius: 0.5rem;
}

.filter-dropdown {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex: 1 1;
}

.filter-dropdown label {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #606060;
}

.filter-dropdown select {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 0.25rem;
  background-color: white;
  font-size: 0.875rem;
  height: 40px;
  transition: border-color 0.2s;
}

.filter-dropdown select:focus {
  border-color: #DA7027;
  outline: none;
}

/* Style responsive */
@media (max-width: 768px) {
  .annuaire-filters {
    flex-direction: column;
  }
  
  .filter-dropdown {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Annuaire/Annuaire.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,eAAe,EAAE,2CAA2C;AAC9D;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;AAC1B;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB,GAAG,+CAA+C;AAC7E;;AAEA;EACE,2CAA2C,GAAG,8BAA8B;AAC9E;;AAEA;EACE,yBAAyB,GAAG,gDAAgD;EAC5E,0BAA0B,GAAG,8BAA8B;AAC7D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB,GAAG,0CAA0C;AACrE;;AAEA;EACE,cAAc,GAAG,wCAAwC;AAC3D;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".annuaire-page {\r\n    width: 100%;\r\n    padding: 2rem 3.5rem;\r\n}\r\n\r\n.annuaire-page h1 {\r\n    margin-bottom: 3rem;\r\n}\r\n\r\n.annuaire-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 2rem 0;\r\n}\r\n\r\n.header-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.entreprise-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n\r\n.avatar-placeholder {\r\n  width: 4rem;\r\n  height: 4rem;\r\n  border-radius: 50%;\r\n  background-color: #E5E7EB;\r\n  overflow: hidden;\r\n}\r\n\r\n.action-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 1.8rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.action-button:hover {\r\n  color: #DA7027;\r\n}\r\n\r\n.entreprise-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.entreprise-logo {\r\n  width: 50px;\r\n  height: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  border-radius: 4px;\r\n}\r\n\r\n.entreprise-logo img {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.entreprise-nom {\r\n  font-weight: 500;\r\n}\r\n\r\n.information-cell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.contact-name {\r\n  font-weight: 700;\r\n}\r\n\r\n/* Remplacer le style existant des documents-cell */\r\n.documents-cell {\r\n  position: relative;\r\n  max-width: 60px; /* Réduit car on n'a plus de texte à côté */\r\n}\r\n\r\n/* Style pour le bouton qui affichera les documents */\r\n.documents-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 0.25rem;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  color: #2C3948;\r\n  transition: color 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.documents-toggle:hover {\r\n  color: #DA7027;\r\n}\r\n\r\n.documents-toggle svg {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n/* Style pour le bouton qui n'affiche que l'icône */\r\n.documents-toggle.documents-icon-counter {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: transparent;\r\n  border: none;\r\n  padding: 4px;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.documents-toggle.documents-icon-counter:hover {\r\n  transform: scale(1.2);\r\n}\r\n\r\n.document-outline-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.documents-count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  width: 18px;\r\n  height: 18px;\r\n  font-size: 1.5rem;\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n/* Popup pour afficher les documents */\r\n.documents-popup {\r\n  position: absolute;\r\n  top: 0%;\r\n  left: -279px;\r\n  margin-bottom: 4px;\r\n  background-color: white;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  padding: 12px;\r\n  z-index: 100;\r\n  min-width: 280px;\r\n  max-width: 400px;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transform: translateY(8px);\r\n  transition: opacity 0.2s, visibility 0.2s, transform 0.2s;\r\n}\r\n\r\n.documents-popup-list {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    flex-direction: column;\r\n}\r\n\r\n/* Pour les lignes en bas du tableau, afficher le popup au-dessus */\r\n.tableau-de-bord-table tr:nth-last-child(-n+3) .documents-popup {\r\n  bottom: auto;\r\n  top: 100%;\r\n  margin-top: 4px;\r\n  margin-bottom: 0;\r\n  transform: translateY(-8px);\r\n}\r\n\r\n.documents-cell:hover .documents-popup {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transform: translateY(0);\r\n}\r\n\r\n.documents-list {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.document-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background-color: rgba(215, 217, 217, 0.20);\r\n  text-decoration: none;\r\n  font-size: 0.85rem;\r\n  padding: 6px 8px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s ease;  /* Transition douce pour tous les changements */\r\n}\r\n\r\n.document-item:hover {\r\n  background-color: rgba(194, 194, 194, 0.46);  /* Couleur de fond au survol */\r\n}\r\n\r\n.document-item:active {\r\n  background-color: #E5E7EB;  /* Couleur légèrement plus foncée lors du clic */\r\n  transform: translateY(1px);  /* Léger effet d'enfoncement */\r\n}\r\n\r\n.document-item .document-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n  transition: color 0.2s;  /* Transition pour la couleur de l'icône */\r\n}\r\n\r\n.document-item:hover .document-icon {\r\n  color: #DA7027;  /* Même couleur que le texte au survol */\r\n}\r\n\r\n.document-item svg {\r\n  width: 16px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.document-link {\r\n  color: #2C3948;\r\n  text-decoration: none;\r\n  font-size: 0.875rem;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.document-link:hover {\r\n  text-decoration: underline;\r\n  color: #DA7027;\r\n}\r\n\r\n/* Animation pour l'apparition du popup */\r\n@keyframes fadeIn {\r\n  from { opacity: 0; transform: translateY(-5px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.documents-popup {\r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n/* Styles pour l'en-tête du tableau */\r\n.tableau-de-bord-header {\r\n  background-color: #F3F4F6;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Définir des largeurs fixes pour les colonnes du tableau */\r\n.categorie-cell {\r\n  max-width: 150px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.departement-cell {\r\n  max-width: 120px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rang-cell {\r\n  max-width: 60px;\r\n  text-align: center;\r\n}\r\n\r\n.entreprise-cell {\r\n  max-width: 200px;\r\n}\r\n\r\n.information-cell {\r\n  max-width: 180px;\r\n}\r\n\r\n/* Styles pour les filtres dropdown */\r\n.annuaire-filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  margin-bottom: 1.5rem;\r\n  padding: 1rem;\r\n  background-color: #f7f7f7;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.filter-dropdown {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 200px;\r\n  flex: 1;\r\n}\r\n\r\n.filter-dropdown label {\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: #606060;\r\n}\r\n\r\n.filter-dropdown select {\r\n  padding: 0.5rem 1rem;\r\n  border: 1px solid #ddd;\r\n  border-radius: 0.25rem;\r\n  background-color: white;\r\n  font-size: 0.875rem;\r\n  height: 40px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.filter-dropdown select:focus {\r\n  border-color: #DA7027;\r\n  outline: none;\r\n}\r\n\r\n/* Style responsive */\r\n@media (max-width: 768px) {\r\n  .annuaire-filters {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .filter-dropdown {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
